<template>
  <div>
    <div class="font-14 font-weight-bold">
      <span class="color-orange-light-2 mr-2">
        {{ $t('lblWizardStep3SectionTitle.text') }}
        <span class="align-sub">* * *</span>
      </span>
      <span class="color-dark-blue">{{ $t('lblWizarStep3Title.text') }}</span>
    </div>

    <div v-if="!isReadOnly">
      <validation-observer ref="formRef" v-slot="{}" tag="form">
        <div class="d-flex align-items-center mt-4">
          <span class="fa-stack fa-1x font-10 ml-n1">
            <em class="fas fa-circle fa-stack-2x color-orange-light-2"></em>
            <span class="fa-stack-1x color-white">1</span>
          </span>
          <span class="color-black-2 font-weight-bold font-14 ml-2">
            {{ $t('lblWizarStep3RequestPurpose.text') }}
          </span>
        </div>
        <div class="mt-3">
          <custom-radio-text
            name="rbRequestType"
            :rb-value="itemSubTypeEnum.ValidateInstrumentsOrPilotTest"
            v-model="model.requestTypeId"
            :main-text="$t('lblWizarStep3RequestPilot.text')"
            :sub-text="$t('lblWizarStep3RequestPilotRequirement.text')"
            :validity-text="$t('ValidityTime6Month')"
            :disabled="isEdit"
            @input="onChangeRequestTypeHandler"
            class="bg-white"
          />
          <custom-radio-text
            class="mt-3 bg-white"
            name="rbRequestType"
            :rb-value="itemSubTypeEnum.ConductResearch"
            v-model="model.requestTypeId"
            :main-text="$t('lblWizarStep3RequestInvestigationRealization.text')"
            :sub-text="
              $t('lblWizarStep3RequestInvestigationRealizationRequirement.text')
            "
            :validity-text="$t('ValidityTime12Month')"
            :disabled="isEdit"
            @input="onChangeRequestTypeHandler"
          />

          <validation-provider
            :rules="{ required_if: !model.requestTypeId }"
            v-slot="{ errors }"
          >
            <custom-error
              v-if="errors[0]"
              class="no-border mt-2"
              :message="`${$t('RequestPurposeValidator.ErrorMessage')}`"
            />
          </validation-provider>

          <div class="mt-2">
            <school-list
              :info="schoolDataMapped"
              @input="onChangeSchoolListHandler"
            />
            <validation-provider
              :rules="{
                required_if:
                  !model.schoolIds.length && !model.schoolDependencies,
              }"
              v-slot="{ errors }"
            >
              <custom-error
                v-if="errors[0]"
                class="no-border mt-2"
                :message="`${$t('SchoolDependenciesValidator.ErrorMessage')}`"
              />
            </validation-provider>
          </div>
          <div class="mt-4">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              <span v-if="isRequestTypeInstrumentsOrPilotTest">
                {{
                  $t(
                    'requestTypePiloto_lblWizarStep3SchoolDependeciesRequirement'
                  )
                }}:
              </span>
              <span v-if="isRequestTypeConductResearch">
                {{
                  $t(
                    'requestTypeInvestigation_lblWizarStep3SchoolDependeciesRequirement'
                  )
                }}:
              </span>
            </div>
            <custom-text-area
              v-model="model.schoolDependencies"
              :maxlength="500"
              show-char-count
            />
          </div>
        </div>
        <div class="d-flex align-items-center mt-5">
          <span class="fa-stack fa-1x font-10 ml-n1">
            <em class="fas fa-circle fa-stack-2x color-orange-light-2"></em>
            <span class="fa-stack-1x color-white">2</span>
          </span>
          <span class="color-black-2 font-weight-bold font-14 ml-2">
            {{ $t('lblWizarStep3ARequestResponseOptionTitle.text') }}
          </span>
        </div>
        <div>
          <div class="row mt-4">
            <div class="col-md-4">
              <custom-radio-text
                class="bg-white"
                hide-validity-info
                name="rbRequestSchoolType"
                :rb-value="1"
                v-model="model.requestSolicitorId"
                :main-text="$t('lblWizarStep3RequestResponseStudySchool.text')"
                @input="onChangeRequestSchoolType"
              />

              <validation-provider
                v-if="isSchoolRequestType"
                rules="required"
                v-slot="{ errors }"
              >
                <div class="color-primary-4 font-14 font-weight-bold mb-1 mt-3">
                  {{
                    $t(
                      'lblWizarStep3RequestResponseStudySchoolRequirement.text'
                    ) | capitalize
                  }}
                </div>
                <custom-drop-down
                  v-model="model.university"
                  :placeholder="$t('Item-Empty')"
                  :options="catalog.universities"
                  fieldkey="id"
                  fieldname="name"
                  class="case-info__dropdown input__exteded"
                  :error="errors[0]"
                  :custom-error-msg="$t('RequiredField')"
                />
              </validation-provider>
            </div>
            <div class="col-md-4">
              <custom-radio-text
                class="bg-white"
                hide-validity-info
                name="rbRequestSchoolType"
                :rb-value="2"
                v-model="model.requestSolicitorId"
                :main-text="$t('ApplicantionRespondToPetitionDescription2')"
                @input="onChangeRequestSchoolType"
              />
              <validation-provider
                v-if="isOrganizationRequestType"
                rules="required"
                v-slot="{ errors }"
              >
                <custom-text-area
                  :placeholder="$t('OrganizationNameSpecification')"
                  :maxlength="500"
                  v-model="model.requestSolicitorDescription"
                  show-char-count
                  :error="errors[0]"
                  :custom-error-msg="$t('RequiredField')"
                  class="mt-3"
                />
              </validation-provider>
            </div>
            <div class="col-md-4">
              <custom-radio-text
                class="bg-white"
                hide-validity-info
                name="rbRequestSchoolType"
                :rb-value="3"
                v-model="model.requestSolicitorId"
                :main-text="$t('Others')"
                @input="onChangeRequestSchoolType"
              />
              <validation-provider
                v-if="isOtherRequestType"
                rules="required"
                v-slot="{ errors }"
              >
                <custom-text-area
                  :placeholder="$t('OtherSpecification')"
                  :maxlength="500"
                  v-model="model.requestSolicitorDescription"
                  show-char-count
                  :error="errors[0]"
                  :custom-error-msg="$t('RequiredField')"
                  class="mt-3"
                />
              </validation-provider>
            </div>
            <div class="col-md-4">
              <validation-provider
                :rules="{ required_if: !model.requestSolicitorId }"
                v-slot="{ errors }"
              >
                <custom-error
                  v-if="errors[0]"
                  class="no-border mt-2"
                  :message="`${$t('RequestResponseOption.ErrorMessage')}`"
                />
              </validation-provider>
            </div>
          </div>
        </div>
      </validation-observer>
    </div>

    <div v-else class="mt-4">
      <div>
        <div class="d-flex align-items-center mt-4">
          <span class="fa-stack fa-1x font-10 ml-n1">
            <em class="fas fa-circle fa-stack-2x color-orange-light-2"></em>
            <span class="fa-stack-1x color-white">1</span>
          </span>
          <span class="color-black-2 font-weight-bold font-14 ml-2">
            {{ $t('lblWizarStep3RequestPurpose.text') }}
          </span>
        </div>
        <div class="bg-dark-blue-2 rounded p-3 d-flex align-items-center mt-4">
          <div class="circle mr-2">
            <div class="dot"></div>
          </div>
          <span class="color-white font-14 flex-grow-1">
            {{ requestTypeDescription }}
          </span>
          <div>
            <div class="color-white font-10">
              {{ $t('ValidityTime') | capitalize }}:
            </div>
            <span class="color-white font-12 font-weight-bold">
              {{ requestTypeValidityTimeDescription }}
            </span>
          </div>
        </div>
        <school-list
          class="mx-n3"
          :info="schoolDataMapped"
          :is-read-only="isReadOnly"
        />
        <div class="bg-white rounded p-3">
          <div class="color-gray-18 font-14">
            {{ schoolDependencyDescription }}
          </div>
          <span class="color-black font-14">
            {{ model.schoolDependencies | empty }}
          </span>
        </div>
      </div>
      <div class="mt-4">
        <div class="d-flex align-items-center mt-5">
          <span class="fa-stack fa-1x font-10 ml-n1">
            <em class="fas fa-circle fa-stack-2x color-orange-light-2"></em>
            <span class="fa-stack-1x color-white">2</span>
          </span>
          <span class="color-black-2 font-weight-bold font-14 ml-2">
            {{ $t('lblWizarStep3ARequestResponseOptionTitle.text') }}:
          </span>
        </div>
        <div
          class="bg-dark-blue-2 rounded p-3 d-flex align-items-center mt-4 w-25"
        >
          <div class="circle mr-2">
            <div class="dot"></div>
          </div>
          <span class="color-white font-14 flex-grow-1">
            {{ requestSolicitorDescription }}
          </span>
        </div>
        <div class="mt-3">
          <div v-if="isSchoolRequestType" class="color-gray-18 font-14">
            {{
              $t('lblWizarStep3RequestResponseStudySchoolRequirement.text')
                | capitalize
            }}:
          </div>
          <div v-if="isOrganizationRequestType" class="color-gray-18 font-14">
            {{ $t('ApplicantionRespondToPetitionDescription2') }}:
          </div>
          
          <div v-if="isOtherRequestType" class="color-gray-18 font-14">
            {{ $t('Others') }}:
          </div>
          <span v-if="isSchoolRequestType" class="color-black font-14">
            {{ model.university.name | empty }}
          </span>
          <span v-else class="color-black font-14">
            {{ model.requestSolicitorDescription | empty }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//libs
import CustomDropDown from 'custom-drop-down';
import CustomTextArea from 'CustomTextArea';
import CustomError from 'custom-error';

//components
import CustomRadioText from '../../common/CustomRadioText.vue';
import { SchoolList } from '../../components';

//services
import { getUniversities as _getUniversities } from '@/services/code.api.js';

//constants
import requestSchoolTypes from '@/utils/constants/requestSchoolTypes';
import { itemSubTypes } from '@/utils/constants/itemSubTypes.js';
import { i18n } from '@/i18n';

export default {
  name: 'ResearchInformation',
  components: {
    CustomRadioText,
    CustomDropDown,
    CustomTextArea,
    CustomError,
    SchoolList,
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: this.info || {
        schoolIds: [],
        schoolsData: [],
        university: null,
        organizationComment: null,
        otherComment: null,
      },
      catalog: {
        universities: [],
      },
    };
  },
  computed: {
    isRequestTypeInstrumentsOrPilotTest() {
      return (
        !this.model.requestTypeId ||
        this.model.requestTypeId === itemSubTypes.ValidateInstrumentsOrPilotTest
      );
    },
    isRequestTypeConductResearch() {
      return this.model.requestTypeId === itemSubTypes.ConductResearch;
    },
    isSchoolRequestType() {
      return this.model.requestSolicitorId === requestSchoolTypes.school;
    },
    isOrganizationRequestType() {
      return this.model.requestSolicitorId === requestSchoolTypes.organization;
    },
    isOtherRequestType() {
      return this.model.requestSolicitorId === requestSchoolTypes.other;
    },
    itemSubTypeEnum() {
      return itemSubTypes;
    },
    requestTypeDescription() {
      return this.model.requestType?.id ===
        itemSubTypes.ValidateInstrumentsOrPilotTest
        ? i18n.t('lblWizarStep3RequestPilot.text')
        : i18n.t('lblWizarStep3RequestInvestigationRealization.text');
    },
    requestTypeValidityTimeDescription() {
      return this.model.requestType?.id ===
        itemSubTypes.ValidateInstrumentsOrPilotTest
        ? i18n.t('ValidityTime6Month')
        : i18n.t('ValidityTime12Month');
    },
    schoolDependencyDescription() {
      return this.model.requestType?.id ===
        itemSubTypes.ValidateInstrumentsOrPilotTest
        ? i18n.t('requestTypePiloto_lblWizarStep3SchoolDependeciesRequirement')
        : i18n.t(
            'requestTypeInvestigation_lblWizarStep3SchoolDependeciesRequirement'
          );
    },
    requestSolicitorDescription() {
      if (this.model.requestSolicitorId === requestSchoolTypes.school)
        return i18n.t('lblWizarStep3RequestResponseStudySchool.text');

      if (this.model.requestSolicitorId === requestSchoolTypes.organization)
        return i18n.t('ApplicantionRespondToPetitionDescription2');

      if (this.model.requestSolicitorId === requestSchoolTypes.other)
        return i18n.t('Others');

      return '';
    },
    schoolDataMapped() {
      return (
        (this.info?.schoolData || this.model.schoolData)?.map((item) => ({
          id: item.id,
          region: {
            name: item.regionName,
          },
          municipality: {
            name: item.districtName,
          },
          school: {
            id: item.schoolId,
            name: item.schoolName,
          },
        })) ?? []
      );
    },
  },
  async mounted() {
    if (!this.isReadOnly) await this.getUniversities();
  },
  methods: {
    getModel() {
      return { ...this.model };
    },
    setModel(value) {
      this.model = {
        ...this.model,
        ...value,
      };
    },
    async getUniversities() {
      this.catalog.universities = (await _getUniversities()).data;
    },
    async validate() {
      return await this.$refs.formRef.validate();
    },
    onChangeRequestTypeHandler(value) {
      this.model.requestTypeId = value;
    },
    onChangeRequestSchoolType(value) {
      this.model.requestSolicitorId = value;
      this.model.university = null;
      this.model.requestSolicitorDescription = null;
    },
    onChangeSchoolListHandler({ schoolIds, schoolsData }) {
      this.model.schoolIds = [...schoolIds];
      this.model.schoolsData = [...schoolsData];
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/components/action-button/index.scss';

.circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #275468;
}
</style>
